import { atomWithReset } from "jotai/utils";

export const timer = {
  status: false,
  timeLeft: 0
};

export const progressAtom = atomWithReset(timer);
